import PropTypes from "prop-types";

// Layouts
import CustomizedSwitches from "@Layouts/components/InputComponents/CustomizedSwitches";

// MUI
import { Stack, Typography } from "@mui/material";

function TextLabel(props) {
	const { checked, disabled, isTotalPay } = props;

	let label = "% of Total Gross";
	if (isTotalPay || !checked) {
		label = "% of Total Pay";
	}
	return (
		<Typography className="regular-pt-sans-pro-narrow-label" noWrap sx={{ minWidth: "85px", opacity: disabled ? 0.6 : 1 }}>
			{label}
		</Typography>
	);
}
TextLabel.propTypes = {
	checked: PropTypes.bool,
	disabled: PropTypes.bool,
	isTotalPay: PropTypes.bool,
};

export default function PercentOfTotal(props) {
	const { checked = false, isTotalPay = false, disabled = false, handleUpdate = () => {} } = props;

	return (
		<Stack position={"absolute"} style={{ right: 0 }}>
			<CustomizedSwitches
				textRight
				checked={checked}
				disabled={disabled}
				textChecked={<TextLabel checked={checked} isTotalPay={isTotalPay} disabled={disabled} />}
				textUnChecked={<TextLabel checked={checked} isTotalPay={isTotalPay} disabled={disabled} />}
				onChange={(value) => handleUpdate?.(value)}
				tooltip={{
					title: "To indicate the correct option to execute the total pay.",
					placement: "left",
					key: "customer-satisfaction-evaluate-tooltip",
				}}
			/>
		</Stack>
	);
}
PercentOfTotal.propTypes = {
	checked: PropTypes.bool,
	isTotalPay: PropTypes.bool,
	disabled: PropTypes.bool,
	handleUpdate: PropTypes.func,
};
